import { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import ComparisonSection from "./components/ComparisonSection";
import SEOArticlesSection from "./components/SEOArticlesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import CTASection from "./components/CTASection";
import HomeFooter from "./components/HomeFooter";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://allchinabuy.team";

const homepageStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "AllChinaBuy Spreadsheet – Verified China Sourcing Database 2026",
  "description": "Discover the AllChinaBuy Spreadsheet – a structured China sourcing database with verified suppliers, agent comparisons, and real-time pricing updates.",
  "url": `${siteUrl}/`,
  "about": {
    "@type": "Organization",
    "name": "AllChinaBuy Spreadsheet",
    "description": "A structured China sourcing intelligence platform providing verified supplier data and agent comparisons for dropshippers and resellers.",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg"
  }
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(homepageStructuredData);
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <SEOArticlesSection />
        <HowItWorksSection />
        <CTASection />
      </main>
      <HomeFooter />
    </div>
  );
}